module.exports = __webpack_public_path__ + "img/Artboard 4.bcba8bbc.png";